
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.7 12C21.7 17.081 17.581 21.2 12.5 21.2C7.41898 21.2 3.3 17.081 3.3 12C3.3 6.91898 7.41898 2.8 12.5 2.8C17.581 2.8 21.7 6.91898 21.7 12ZM23.5 12C23.5 18.0751 18.5751 23 12.5 23C6.42487 23 1.5 18.0751 1.5 12C1.5 5.92487 6.42487 1 12.5 1C18.5751 1 23.5 5.92487 23.5 12ZM13.1644 6.25272C12.9813 6.08996 12.7449 6.00003 12.5 6C12.2348 6 11.9804 6.10536 11.7929 6.29289C11.6054 6.48043 11.5 6.73478 11.5 7V12L11.509 12.131C11.5378 12.349 11.6376 12.5514 11.793 12.707L14.793 15.707L14.887 15.79C15.088 15.9454 15.3406 16.0185 15.5935 15.9944C15.8464 15.9703 16.0807 15.8508 16.2488 15.6603C16.4168 15.4697 16.506 15.2223 16.4982 14.9684C16.4905 14.7144 16.3863 14.473 16.207 14.293L13.5 11.586V7L13.493 6.883C13.4643 6.63975 13.3474 6.41547 13.1644 6.25272Z","fill":"#16171F"}})])
          )
        }
      }
    